module.exports = __webpack_public_path__ + "images/emoji/recycle.a955a6ab79eab367fb85.png";